import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { encenderAnalitica } from "./lib/analiticaGA4";
import "./styles/global.css";

const raiz = document.getElementById("root");
if (!raiz) throw new Error("No se encontró el nodo raíz");

/*
 * Aquí y no dentro de un componente.
 *
 * Con `StrictMode` React monta, desmonta y vuelve a montar en desarrollo, así
 * que un efecto encendería la analítica dos veces. Fuera del árbol ocurre una
 * sola vez, y además no retrasa el primer pintado: no se espera.
 */
void encenderAnalitica().then((r) => {
  if (import.meta.env.DEV) console.info(`analítica: ${r}`);
});

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>
);
